import { memo } from 'preact/compat';
import { useContext } from 'preact/hooks';

import ServiceLogo from './ServiceLogo';
import { warn } from '../../lib/Log';
import ViewContext from '../../view/ViewContext';

function Service() {
	const { props } = useContext(ViewContext) || {};
	const { service } = props || {};
	const { id, href, logo, icon } = service || {};

	if (!logo?.src) {
		warn('Service logo is required for service to render.');

		return null;
	}

	return (
		<a
			className='ribbon-service'
			href={href || '/'}
			data-dot={`lista_${id}`}
			data-e2e='ribbon-service'
		>
			<ServiceLogo
				iconSrc={icon?.src}
				iconLabel={icon?.label}
				logoSrc={logo.src}
				logoHeight={logo.height}
			/>
		</a>
	);
}

export { Service };
export default memo(Service);
